import moment from "moment";
import { convertDateToLocal } from "utils/misc";

export const getAppointmentAriaDescription = (action, chatDetails) => {
  if (
    !chatDetails.dme_details?.name ||
    !chatDetails.date_time ||
    !chatDetails.start_time
  )
    return "";

  const dmeName = chatDetails.dme_details.name;
  const appointmentDate = moment(chatDetails.date_time).format("MMMM D");
  const appointmentTime = moment(
    convertDateToLocal(chatDetails.start_time, false)
  ).format("h:mm A");

  return `${action} appointment with ${dmeName}, ${appointmentDate}, ${appointmentTime}`;
};

export const getCancelAriaLabelledBy = chatDetails => {
  return getAppointmentAriaDescription("Cancel", chatDetails);
};

export const getRescheduleAriaDescribedBy = chatDetails => {
  return getAppointmentAriaDescription("Reschedule", chatDetails);
};

export const getJoinAriaDescribedBy = dmeDetails => {
  if (!dmeDetails?.name) return "";
  const dmeName = dmeDetails.name;
  return `Join appointment with ${dmeName}`;
};

export const getJoinAriaLabel = chatDetails => {
  return getAppointmentAriaDescription("Join", chatDetails);
};
